<template>
  <div class="PersonVacationListWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 50, 100, -1],
        'items-per-page-text': $t('rowsPerPage'),
        'show-first-last-page': true,
      }"
      @click:row="handleClick"
    >
      <template v-slot:item.select="{ item }">
        <v-checkbox
          dense
          hide-details="true"
          v-model="item.select"
          @click.stop=""
        ></v-checkbox>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      selectedList: [],
      headers: [
        {
          text: this.$t("card-no"),
          value: "perno",
        },
        {
          text: this.$t("person-name"),
          value: "personName",
        },
        {
          text: this.$t("SectionName"),
          value: "SectionName",
        },
        {
          text: this.$t("status"),
          value: "Statustype",
        },
        {
          text: this.$t("RequestDate"),
          value: "RecDate",
        },
        {
          text: this.$t("periodOrMonth"),
          value: "Period",
        },
        {
          text: this.$t("specificExtraWork"),
          value: "Amount",
        },
        {
          text: this.$t(""),
          value: "select",
        },
      ],
    };
  },
  methods: {
    handleClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>

<style>
</style>